import React from 'react';

export const APIEndpointContext = React.createContext("APIEndpointContext is not loaded yet.");
